import { useContext } from "react";
import { QueryClientContext } from "@tanstack/react-query";
import { ReactReduxContext } from "react-redux";
import { useNextT } from "../../i18n";
import { rich } from "../../contacts/components/dialogs";
import { useAccess } from "../api";
import s from "./Notices.module.scss";

/**
 * Owner note A5 (2026-10-25): on a screen that says "no", "blocked" or "something went wrong", the way forward is a person:
 * "Having a problem? Contact your manager: <name> (<email>)" — the account's Owner, called "manager" to everyone. Shown only to
 * a member of the account (the server sends the address to no one else), never to the Owner himself, and not at all while the
 * answer is missing (then there is no one to name). Safe to place anywhere: without the app's providers it renders nothing.
 */
const Line = () => {
  const { t } = useNextT();
  const data = useAccess().data;
  const owner = data?.workspace.owner;
  if (!owner?.email || data?.role === "owner") return null;
  return (
    <p className={s.help}>
      {rich(t, "access.help_manager", {}, { name: <bdi>{owner.name}</bdi>, email: <bdi>{owner.email}</bdi> })}
    </p>
  );
};

export const ManagerHelp = () => {
  const client = useContext(QueryClientContext);
  const redux = useContext(ReactReduxContext);
  return client && redux ? <Line /> : null;
};
